module.exports = __webpack_public_path__ + "img/visualization.5ef20ad5.jpg";